export default __webpack_public_path__ + "static/media/agent-role-agent-green.3665b29b.svg";